var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullhorn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.0926C22 16.1143 17.5331 20.1851 12.0229 20.1851C10.1607 20.1851 8.41776 19.7202 6.92607 18.9108C6.11674 19.8217 4.81399 20.5048 2.23604 20.9961C2.01441 21.0383 1.9075 20.7256 2.10041 20.6073C3.62237 19.6741 4.33657 18.7504 4.50196 17.0674C2.9723 15.4695 2.04575 13.3796 2.04575 11.0926C2.04575 6.07088 6.51266 2 12.0229 2C17.5331 2 22 6.07088 22 11.0926Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn1);
export default __webpack_public_path__ + "static/media/bullhorn-1.0b7d4231d770684856327edb29ef5ff0.svg";
export { ForwardRef as ReactComponent };